"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Badge_1 = require("./Badge");
exports.default = Badge_1.default;
//# sourceMappingURL=index.js.map